import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    msg: '',
    company_website: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formNote, setFormNote] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Honeypot check
    if (formData.company_website.trim() !== "") {
      setFormNote("Thanks! We'll reach out shortly.");
      return;
    }

    // Animate button (busy → done)
    setIsSubmitting(true);
    setFormNote('');

    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
      setFormNote("Thanks! We'll reach out shortly.");
      setFormData({
        name: '',
        email: '',
        msg: '',
        company_website: ''
      });
      
      // Revert after a short while
      setTimeout(() => {
        setIsSubmitted(false);
        setFormNote('');
      }, 2200);
    }, 1100);
  };

  return (
    <section id="contact" className="container">
      <h2 className="section-title">Let's build something dependable</h2>
      <p className="section-sub">Tell us about your use-case and we'll send a short plan within 48 hours.</p>
      
      <form className="card contact-card" onSubmit={handleSubmit}>
        <div className="contact-fields">
          <label>
            Name
            <input
              required
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Jane Doe"
            />
          </label>
          <label>
            Work email
            <input
              required
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="jane@company.com"
            />
          </label>
        </div>
        
        <label className="contact-message">
          What would you like to build?
          <textarea
            required
            name="msg"
            value={formData.msg}
            onChange={handleInputChange}
            rows="5"
            placeholder="A trustworthy support agent for our customers…"
          />
        </label>
        
        {/* Honeypot */}
        <label className="hp">
          Company website
          <input
            type="text"
            name="company_website"
            value={formData.company_website}
            onChange={handleInputChange}
            tabIndex="-1"
            autoComplete="off"
          />
        </label>
        
        <div className="cta contact-actions">
          <button
            className="btn primary"
            type="submit"
            id="requestPlanBtn"
            disabled={isSubmitting}
            aria-busy={isSubmitting}
          >
            {isSubmitting ? 'Sending…' : isSubmitted ? 'Sent ✓' : 'Request plan'}
          </button>
          {formNote && (
            <span className="contact-note">
              {formNote}
            </span>
          )}
        </div>
      </form>
    </section>
  );
};

export default Contact;
